{
  "Example Page": "Example Page",
  "This text will be translated": "This text will be translated",
  "recipient": "recipient",
  "some.key": "some.key",
  "text": "text"
}
